import * as React from "react";
import { PiletLoader } from "@klantondersteuning-btl/shared";
import { IBaseFormulierPageProps } from "@klantondersteuning/shared";

const AanvragenVozdPageWrapper = React.lazy(() => import("./AanvragenVozdPage"));

export function AanvragenVozdPage(props: IBaseFormulierPageProps) {
  return (
    <div>
      <React.Suspense fallback={<PiletLoader />}>
        <AanvragenVozdPageWrapper
          apiUrl={props.apiUrl}
          pageBaseUrl={props.pageBaseUrl}
          basePath={props.basePath}
          language={props.language}
        />
      </React.Suspense>
    </div>
  );
}
